<template>
  <!-- 轨迹 -->
  <el-dialog :title="'轨迹路线:' + deliver + '→' + delivery" :visible.sync="dialogLine" :before-close="handleClose" class="dialog-large" v-dialogDrag :class="tabs == '4' ?'het':''">
    <el-button type="primary" style="position: absolute; top: 10px; right: 70px" @click="dWtrack">下载<i class="el-icon-download el-icon--right"></i></el-button>
    <!-- <el-button @click="showGuiji">查看</el-button> -->
    <ul class="list-nav clearfix">
      <li @click="handClick('1')" :class="[tabs == '1' ? 'active' : '']">
        北斗+LBS定位
      </li>
      <li @click="handClick('2')" :class="[tabs == '2' ? 'active' : '']">
        APP定位
      </li>
      <li @click="handClick('3')" :class="[tabs == '3' ? 'active' : '']" v-if="showGps">
        硬件轨迹
      </li>
      <li v-if="ship_car_type == 'BOAT_TYPE'" @click="handClick('4')" :class="[tabs == '4' ? 'active' : '']" >海上航运</li>
    </ul>
    <emap-line ref="emap" v-if="isEmap"></emap-line>
    <amap-line ref="amap" v-if="isAmap"></amap-line>
    <sea-map ref="sea" v-if="isSeamap"></sea-map>
    <el-row class="info-wrapper">
      <el-row class="info-bd" v-if="ship_car_type == 'BOAT_TYPE'">
        <el-row class="plate mainColor">{{ waybill_code }}</el-row>
        <el-row class="plate">船舶号：{{ nvo }}</el-row>
        <el-row class="plate">运输距离：{{ distance == null ? '0' : distance }} 千米</el-row>
        <ul class="name-phone">
          <li>姓名：{{ driver_name }}</li>
          <li>手机号:{{ accompany_mobile }}</li>
        </ul>
      </el-row>
      <el-row class="info-bd" v-else-if="tabs!=='4'">
        <el-row class="plate mainColor">{{ waybill_code }}</el-row>
        <el-row class="plate">车牌号：{{ nvo }}</el-row>
        <el-row class="plate">运输距离：{{ distance == null ? '0' : distance }} 千米</el-row>
        <ul class="name-phone">
          <li>姓名：{{ driver_name }}</li>
          <li>手机号:{{ accompany_mobile }}</li>
        </ul>
      </el-row>
      <!-- <el-row class="info-track">
        <span class="info-set" @click="loadList"><img src="../../assets/images/车辆轨迹点.png" class="mr-20"/>车辆轨迹点</span>
      </el-row> -->
      <el-row class="info-track" v-if="tabs!=='4'">
        <span class="info-set"><img src="../../assets/images/车辆预警.png" class="mr-20" />{{ position_status_enum_text }}</span>
      </el-row>
    </el-row>
    <el-row class="guiji-row" v-if="ship_car_type == 'BOAT_TYPE'">
      <el-row v-for="(item, index) in data.content" :key="index" class="guiji-detail">
        <el-row>{{ item.address }}</el-row>
        <el-row>{{ item.track_time }}</el-row>
      </el-row>
    </el-row>
    <el-row class="guiji-row" v-else>
      <el-row v-for="(item, index) in data.content" :key="index" class="guiji-detail">
        <el-row>{{ item.address }}</el-row>
        <el-row>{{ item.track_time }}</el-row>
        <el-row>{{ item.speed }}km/h</el-row>
        <el-row>{{ item.type == 'LUGELBS' || item.type == 'SZWZ' ? 'LBS' : item.type_enum_text }}</el-row>
      </el-row>
    </el-row>
    <el-row class="fenye">
      <el-pagination small layout="total,prev, pager, next" :total="search.paging.total" @current-change="handleCurrentChange" :current-page="search.paging.page_num" :page-size="search.paging.page_size" :pager-count="5" :hide-on-single-page="value"></el-pagination>
    </el-row>
    <!-- <el-row class="guiji-nvo" v-if="mapTypes == 'CAR_TYPE'">
      <span>车牌号：{{nvo}}</span>
      <span style="margin-left:20px">司机姓名：{{driver_name}}</span>
      <span style="margin-left:20px">司机手机号 ：{{accompany_mobile}}</span>
    </el-row>
    <el-row class="guiji-nvo" v-if="mapTypes == 'BOAT_TYPE'">
      <span>船舶号：{{nvo}}</span>
      <span style="margin-left:20px">船长姓名：{{driver_name}}</span>
      <span style="margin-left:20px">船长手机号 ：{{accompany_mobile}}</span>
    </el-row> -->
    <el-row class="info-play" v-if="isAmap&&tabs!=='4'">
      <ul class="info-play-content">
        <li class="info-play-detail" @click="$refs.amap.play()">
          <p><img src="../../assets/images/播放.png" /></p>
          <p>开始</p>
        </li>
        <li class="info-play-detail" @click="$refs.amap.suspend()">
          <p><img src="../../assets/images/暂停.png" /></p>
          <p>暂停</p>
        </li>
        <li class="info-play-detail" @click="$refs.amap.recover()">
          <p><img src="../../assets/images/恢复.png" /></p>
          <p>恢复</p>
        </li>
        <li class="info-play-detail" @click="showSpeed = !showSpeed">
          <p><img src="../../assets/images/倍速.png" /></p>
          <p>倍速</p>
        </li>
      </ul>
      <el-row class="speed" v-if="showSpeed">
        <ul class="flex">
          <li v-for="(item, index) in speedList" :key="index" @click="toSpeed(index)">
            <img :src="item.url" v-if="item.show" />
            <img :src="item.active_url" v-else />
          </li>
        </ul>
      </el-row>
    </el-row>
    <el-dialog title="轨迹列表" :visible.sync="dialogHistory" append-to-body v-dialogDrag class="dialog-lg">
      <el-button type="primary" style="position: absolute; top: 10px; right: 70px" @click="dWtrack">下载<i class="el-icon-download el-icon--right"></i></el-button>
      <el-table class="nth" :empty-text="empty_text" border :data="data.content" ref="multipleTable" :row-style="selectedHighlight" height="350">
        <el-table-column label="定位时间" align="left">
          <template slot-scope="scope">
            <span>{{ scope.row.track_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="地址信息" align="left" min-width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="经度" align="left">
          <template slot-scope="scope">
            <span>{{scope.row.lng}}</span>
          </template>
        </el-table-column>
        <el-table-column label="纬度" align="left">
          <template slot-scope="scope">
            <span>{{scope.row.lat}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="车速" align="left">
          <template slot-scope="scope">
            <span>{{ scope.row.speed }}</span>
          </template>
        </el-table-column>
        <el-table-column label="定位类型" align="left">
          <template slot-scope="scope">
            <span>{{ scope.row.type_enum_text }}</span>
          </template>
        </el-table-column>
      </el-table>
      <paging-default :paging="search.paging" @upup="loadList"></paging-default>
      <el-row class="btn-group sm">
        <el-button type="info" @click="dialogHistory = false">关 闭</el-button>
      </el-row>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { regionDataPlus, CodeToText } from '@/assets/js/app'
import { isSuccess, getToken } from '@/assets/js/utils'
import BaiduMap from '@/components/map/baidu-map'
import SeaMap from './sea-map.vue'
import EmapLine from './emap-line.vue'
export default {
  data() {
    return {
      pid: '',
      status: '',
      nvo: '',
      accompany_mobile: '',
      driver_name: '',
      mapTypes: [],
      points: [],
      addre: '',
      long: '',
      lat: '',
      position_status_enum_text: '',
      dialogLine: false,
      showSpeed: false,
      speedList: [
        {
          url: require('../../assets/images/1倍.png'),
          active_url: require('../../assets/images/1倍-选中.png'),
          show: true
        },
        {
          url: require('../../assets/images/2倍.png'),
          active_url: require('../../assets/images/2倍-选中.png'),
          show: true
        },
        {
          url: require('../../assets/images/3倍.png'),
          active_url: require('../../assets/images/3倍-选中.png'),
          show: true
        },
        {
          url: require('../../assets/images/4倍.png'),
          active_url: require('../../assets/images/4倍-选中.png'),
          show: true
        }
      ],
      // 轨迹列表
      dialogHistory: false,
      isLoading: false,
      search: {
        pid: '',
        paging: {
          page_size: 50,
          page_num: 1,
          total: 0
        }
      },
      data: {
        content: []
      },
      empty_text: '',
      // 下载轨迹
      dWtrackArr: [],
      isEmap: true,
      isAmap: true,
      isSeamap:false,
      deliver: '',
      delivery: '',
      ship_car_type: '',
      value: false,
      waybill_code: '',
      distance: '',
      tabs: '1',
      row: {},
      showGps: false
    }
  },
  computed: {
    latitude: function() {
      return this.lat
    },
    longitude: function() {
      return this.long
    },
    myAddress: function() {
      return this.addre
    },
    mapType: function() {
      return this.mapTypes
    }
  },
  methods: {
    handClick(i) {
      this.tabs = i
      if (this.tabs === '4') {
        this.getseaPoint()
      }else {
        this.isSeamap = false
        this.getPoint()
      }
    },
    getseaPoint() {
      //控制原来组件的逻辑
      this.isEmap = false
      this.isAmap = false
      this.isSeamap = true
      this.$nextTick(() => {
        this.$refs.sea.pid = this.pid
      })
      this.loadList()
    },
    //轨迹
    show(row, i) {
      console.log(row,'11111111111')
      this.row = row
      this.tabs = '1'
      i ? (this.pid = i) : (this.pid = row.pid)
      this.ship_car_type = row.ship_car_type
      this.nvo = row.ship_car_num
      this.driver_name = row.carrier_name
      this.accompany_mobile = row.accompany_mobile
      this.position_status_enum_text = row.position_status_enum_text
      this.deliver = `${row.loading_address_province}${row.loading_address_city}${row.loading_address_area}`
      this.delivery = `${row.unloading_address_province}${row.unloading_address_city}${row.unloading_address_area}`
      this.waybill_code = row.waybill_code
      this.distance = row.distance
      if (this.ship_car_type == 'BOAT_TYPE') {
        this.type = 'BEIDOU'
      }
      this.status = row.position_status
      this.dialogLine = true
      this.getPermission(row.ship_car_num)
      setTimeout(() => {
        this.getPoint()
      }, 1000)
    },
    getPermission(plate_num) {
      api('car.car.gps.locations.bind', { plate_num: plate_num }).then((res) => {
        let data
        if ((data = isSuccess(res))) {
          if (data.is_gps_bind == 'Yes') {
            this.showGps = true
          } else {
            this.showGps = false
          }
        }
      })
    },
    getPoint() {
      this.isEmap = true
      this.isAmap = true
      this.points = []
      this.guijiList = []
      let methodName = ''
      if (this.tabs == '1') {
        methodName = 'waybill.history.track'
      } else if (this.tabs == '2') {
        methodName = 'app.gps.locations.query'
      } else {
        methodName = 'car.car.gps.location'
      }

      api(methodName, { id: this.pid, type: '' }).then((res) => {
        let data = isSuccess(res)
        console.log(data)
        // data = [
        //   {
        //     address: "湖北省武汉市洪山区珞南街道文治街武汉市洪山区人民政府",
        //     lat: "30.49984",
        //     lng: "114.34253",
        //     track_time: "2022-02-18 10:34:11",
        //     type: "LBS定位",
        //   },
        //   {
        //     address: "湖北省武汉市洪山区珞南街道文治街武汉市洪山区人民政府",
        //     lat: "31.49984",
        //     lng: "114.34253",
        //     track_time: "2022-02-18 10:34:11",
        //     type: "LBS定位",
        //   },
        //   {
        //     address: "湖北省武汉市洪山区珞南街道文治街武汉市洪山区人民政府",
        //     lat: "32.49984",
        //     lng: "114.34253",
        //     track_time: "2022-02-18 10:34:11",
        //     type: "LBS定位",
        //   },
        // ]
        if (data.length > 0) {
          data.forEach((item) => {
            item.type == 'BEIDOU' ? (item.type = '北斗定位') : (item.type = 'LBS定位')
            this.points.push({
              lng: item.lng,
              lat: item.lat,
              address: item.address,
              track_time: item.track_time
            })
            this.guijiList.push({
              address: item.address,
              time: item.create_time,
              types: item.type
            })
            this.dWtrackArr.push([item.address, item.track_time, item.type])
          })
          if (this.points.length > 15) {
            this.isEmap = false
            this.isAmap = true
            this.$refs.amap.init(this.points, this.status, this.ship_car_type)
          } else {
            this.isEmap = true
            this.isAmap = false
            console.log(this.points, '**********')
            this.$refs.emap.init(this.points, this.row, true)
          }
        } else {
          this.points = this.row.loading_address_province + this.row.loading_address_city + this.row.loading_address_area
          this.guijiList.push({
            address: ''
          })
          this.isEmap = true
          this.isAmap = false
          console.log(this.row)
          // this.$refs.emap.init(this.points)
          this.$refs.emap.init(this.points, this.row, false)
          // this.$refs.amap.init(this.points)
        }
      })
      this.loadList()
    },
    toSpeed(index) {
      this.speedList.forEach((item, i) => {
        if (index == i) {
          item.show = false
        } else {
          item.show = true
        }
      })
      this.$refs.amap.add(index + 1)
    },
    selectedHighlight({ row, rowIndex }) {
      if (this.getIndex === rowIndex) {
        return {
          'background-color': '#ECF5FF'
        }
      }
    },
    // 轨迹列表
    loadList() {
      // this.dialogHistory = true
      this.search.pid = this.pid
      this.value = false
      let methodName = ''
      if (this.tabs == '1'|| this.tabs == '4') {
        methodName = 'waybill.position.record'
      } else if (this.tabs == '2') {
        methodName = 'app.gps.locations.record'
      } else {
        methodName = 'car.car.gps.location.list'
      }
      api(methodName, this.search).then((res) => {
        let data = isSuccess(res)
        data.forEach((item) => {
          if (item.type == 'SZWZ') {
            item.type_enum_text = '手机定位'
          }
        })
        this.data.content = data
        if (this.data.content.length == 0) {
          this.empty_text = '暂无数据'
        }
        this.search.paging.total = res.data_total
        if (res.data_total <= this.search.paging.page_size) {
          this.value = true
        }
      })
      // this.$message({
      //   message: '该功能正在加紧研发中...',
      //   type: 'success'
      // });
    },
    handleCurrentChange(page_num) {
      this.search.paging.page_num = page_num
      this.loadList()
    },
    // 定位日志
    positionLog() {
      this.dialogHistory = true
      this.search.pid = this.pid
      api('waybill.position.record', this.search).then((res) => {
        let data = isSuccess(res)
        data.forEach((item) => {
          if (item.type == 'SZWZ') {
            item.type_enum_text = '手机定位'
          }
        })
        this.data.content = data
        if (this.data.content.length == 0) {
          this.empty_text = '暂无数据'
        }
        // this.empty_text = '暂无数据'
        this.search.paging.total = res.data_total
      })
      // this.$message({
      //   message: '该功能正在加紧研发中...',
      //   type: 'success'
      // });
    },
    //  showGuiji(){
    //   this.dialogReceiptVisible = true
    //  },
    showGuijia() {
      // https://restapi.amap.com/v3/geocode/regeo?key=2dca18399337636f96b35e6a4a32687a&s=rsv3&language=zh_cn&batch=true&location=1locationradius=1000&callback=jsonp_292350_&platform=JS&logversion=2.0&appname=https%3A%2F%2Fwww.xxzyt.com%2Flocation%2F&csid=AC8D3441-3517-465E-8D77-10736C69663E&sdkversion=1.4.15
      let a = ''
      let location = ''
      for (let i = 0; i < this.points.length; i++) {
        a = `${this.points[i].lng},${this.points[i].lat}&`
        console.log(a)
        location = '116.42468,39.913977%7C116.429845,39.914322%7C116.426214,39.914341%7C116.424706,39.914371%7C114.004647,30.648502%7C114.012012,30.650682%7C114.012012,30.650677'
        // &116.426214,39.914341&116.424706,39.914371&114.004647,30.648502&114.012012,30.650682&114.012012,30.650677
      }
      // https://restapi.amap.com/v3/geocode/regeo?key=940fc205ea12f518def704084411b3e8&s=rsv3&language=zh_cn&batch=true&location=113.979682,30.52594%7C114.001765,30.582802%7C114.012857,30.57894%7C114.001677,30.583102%7C113.980832,30.531597%7C113.957365,30.502942%7C113.98554,30.548502%7C114.012957,30.578992%7C114.012455,30.579057%7C113.986087,30.549035&radius=1000&callback=jsonp_292350_&platform=JS&logversion=2.0&appname=https%3A%2F%2Fwww.xxzyt.com%2Flocation%2F&csid=AC8D3441-3517-465E-8D77-10736C69663E&sdkversion=1.4.15
      // https://restapi.amap.com/v3/geocode/regeo?key=940fc205ea12f518def704084411b3e8&s=rsv3&language=zh_cn&batch=true&location=116.42468,39.913977&116.429845,39.914322&116.426214,39.914341&116.424706,39.914371&114.004647,30.648502&114.012012,30.650682&114.012012,30.650677&radius=1000&callback=jsonp_292350_&platform=JS&logversion=2.0&appname=https%3A%2F%2Fwww.xxzyt.com%2Flocation%2F&csid=AC8D3441-3517-465E-8D77-10736C69663E&sdkversion=1.4.15
      let url = `https://restapi.amap.com/v3/geocode/regeo?key=940fc205ea12f518def704084411b3e8&s=rsv3&language=zh_cn&batch=true&location=${location}&radius=1000`
      axios({
        url: url,
        method: 'get',
        data: {}
        //  responseType: 'blob', // important
      }).then((res) => {
        console.log(res.data.regeocodes)
      })
    },
    //下载按钮
    dWtrack() {
      this.trackth = [] // 先置空,避免数据重叠
      let th = []
      let date = new Date()
      let tody_date = ` ${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      this.trackth = ['定位地点', '定位时间', '定位方式']
      th = this.trackth
      const [fileName, fileType, sheetName] = [`轨迹列表${tody_date}`, 'xlsx', '轨迹列表']
      let data = this.dWtrackArr
      this.$toExcel({ th, data, fileName, fileType, sheetName })
      this.handleClose()
    },
    handleClose() {
      //关闭弹窗按钮
      this.tabs = '1'
      this.isSeamap = false
      this.dialogLine = false
      this.trackth = []
      this.dWtrackArr = []
      this.search.paging.page_num = 1
      this.showSpeed = false
    }
  },
  components: {
    BaiduMap,
    SeaMap
  }
}
</script>
<style scoped lang="scss">
@import 'src/assets/sass/mixin';
/deep/ .el-dialog__body {
  max-height: 650px;
}
.het /deep/ .el-dialog__body {
  height: 605px;
}
.guiji-box {
  position: relative;
}
.info-wrapper {
  width: 200px;
  background: #fff;
  position: absolute;
  left: 40px;
  top: 200px;
  z-index: 99;
  -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  /* height: 240px; */
}
.info-bd {
  padding: 0 20px;
}
.plate {
  padding: 15px 0;
  font-weight: 600;
  font-size: 16px;
  border-top: 1px solid #f5f5f5;
}
.info-set {
  background: #f5f5f5;
  padding: 15px 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  // cursor: pointer;
}
.name-phone > li {
  margin-bottom: 10px;
}
.info-track {
  border-bottom: 1px solid #e5e5e5;
}
.mr-20 {
  margin-right: 20px;
}
.ml-20 {
  margin-left: 20px;
}
.info-play {
  width: 110px;
  background: rgb(255, 249, 249);
  position: absolute;
  right: 25%;
  top: 35%;
  z-index: 99;
  -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.info-play-content {
  border-bottom: 1px solid #e5e5e5;
}
.info-play-detail {
  background: #ffffff;
  padding: 15px 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  justify-content: space-around;
}
.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  cursor: pointer;
}
.flex > li {
  padding: 15px;
}
.speed {
  width: 250px;
  background: #ffffff;
  position: absolute;
  right: -5%;
  bottom: -20%;
  z-index: 99;
  -webkit-box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}
.fenye {
  position: absolute;
  right: 20px;
  bottom: 0;
  background: #fff;
  width: 18%;
}
.list-nav {
  border-bottom: 1px solid #e4e7ed;
  margin-right: 10px;
  width: 100%;
  margin-bottom: 10px;
}
.list-nav li {
  float: left;
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  background: #fff;
  cursor: pointer;
}
.list-nav li.active {
  color: $mainColor;
  border-bottom: 2px solid $mainColor;
}
.list-nav li:hover {
  color: $mainColor;
}
</style>



// WEBPACK FOOTER //
// src/components/map/waybill-map.vue